import { ConfigurationStep } from '../../api/hooks/useConfigurationStep';

export function getConfigurationStepFromIndex(
  index: number
): ConfigurationStep | undefined {
  switch (index) {
    case 0:
      return ConfigurationStep.CHECKLIST;
    case 1:
      return ConfigurationStep.FITCONNECTCLIENT;
    case 2:
      return ConfigurationStep.DESTINATIONS;
    case 4:
      return ConfigurationStep.DATAMODELS;
    case 5:
      return ConfigurationStep.SENDERCONFIG;
    case 6:
      return ConfigurationStep.BUNDID;
    case 7:
      return ConfigurationStep.LOGO;
    case 8:
      return ConfigurationStep.FOOTER;
    case 9:
      return ConfigurationStep.SUMMARY;
    case 10:
      return ConfigurationStep.FINISH;
    default:
      return undefined;
  }
}

export function getIndexOfConfigurationStep(
  configurationStep?: ConfigurationStep
) {
  if (!configurationStep) {
    return 0;
  }
  switch (configurationStep) {
    case ConfigurationStep.CHECKLIST:
      return 0;
    case ConfigurationStep.FITCONNECTCLIENT:
      return 1;
    case ConfigurationStep.DESTINATIONS:
      return 2;
    case ConfigurationStep.DATAMODELS:
      return 4;
    case ConfigurationStep.SENDERCONFIG:
      return 5;
    case ConfigurationStep.BUNDID:
      return 6;
    case ConfigurationStep.LOGO:
      return 7;
    case ConfigurationStep.FOOTER:
      return 8;
    case ConfigurationStep.SUMMARY:
      return 9;
    case ConfigurationStep.FINISH:
      return 10;
    default:
      return 0;
  }
}
